import { motion } from "framer-motion";

/**
 * Slow editorial marquee — single, purposeful. Serif font, wide tracking.
 */
export default function EditorialMarquee({
  items = [
    "Cinematic Execution",
    "Architectural Precision",
    "Masterfully Engineered",
    "Surrey · Metro Vancouver · BC",
    "By Private Appointment",
  ],
}) {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <section
      className="relative border-y border-white/5 py-10 md:py-14 bg-[var(--bg)] overflow-hidden"
      data-testid="editorial-marquee"
    >
      <motion.div
        className="marquee-track whitespace-nowrap"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1 }}
      >
        {doubled.map((item, i) => (
          <span key={i} className="inline-flex items-center pr-14 md:pr-24">
            <span className="font-serif-editorial italic text-[9vw] md:text-[7vw] leading-none text-[var(--ink)]/90">
              {item}
            </span>
            <span className="numeral text-[8vw] md:text-[6vw] px-8 md:px-14">✦</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
